// extracted by mini-css-extract-plugin
export default {"authWrap":"AuthLayout_authWrap__bE6kt"};